import { getStoredAuthToken } from "./authTokenStorage";

export { default as baseUrl } from "./apiBaseUrl";

function getStoredToken() {
  return getStoredAuthToken();
}

export function authHeaders(headers = {}) {
  const token = getStoredToken();

  if (!token) {
    return headers;
  }

  return {
    ...headers,
    Authorization: `Bearer ${token}`,
  };
}

export async function handleResponse(response, notifyAccessChange = true) {
  if (response.ok) {
    if (response.status === 204) return null;
    if (typeof response.text === "function") {
      const body = await response.text();
      if (!body) return null;
      return JSON.parse(body);
    }
    return response.json();
  }
  if (response.status === 401) {
    throw Object.assign(new Error("Unauthorized"), { code: 401 });
  }
  if (response.status === 400) {
    let message = await response.text();
    try {
      const parsed = JSON.parse(message);
      if (typeof parsed === "string") message = parsed;
    } catch (parseError) {
      // Plain text validation messages remain unchanged.
    }
    throw new Error(message);
  }
  if (response.status === 403) {
    const error = await response.text();
    let message = error || "Forbidden";
    try {
      const parsed = JSON.parse(error);
      message = parsed.error || parsed.message || message;
    } catch (parseError) {
      if (!parseError) message = error;
      // Keep plain text permission responses as-is.
    }
    const forbiddenError = new Error(message === "Forbidden" ? "Brak uprawnien" : message);
    forbiddenError.code = 403;
    if (notifyAccessChange && typeof window !== 'undefined') window.dispatchEvent(new Event('teacher-access-denied'));
    throw forbiddenError;
  }
  const error = await response.text();
  if (response.status === 409) {
    let message = error;
    try {
      const parsed = JSON.parse(error);
      message = parsed.error || parsed.message || error;
    } catch (parseError) {
      // Plain text conflict responses remain readable by the application translator.
    }
    throw Object.assign(new Error(message), { code: 409 });
  }
  const responseError = new Error(`Network response was not ok. status:${response.status} error:${error}`);
  responseError.code = response.status;
  throw responseError;
}

// In a real app, would likely call an error logging service.
export function handleError(error) {
  // eslint-disable-next-line no-console
  console.error(`API call failed. ${error}`);
  throw error;
}
